import { Anchor } from "@newsela/angelou";
import { NO_VALUE } from "@/reports/teacher/common/ReportTable/constants";
import { TableCellTypesProps } from "../TableCells.interface";
import { commonLevelCss } from "../TableCells.style";

const GeneralTableCell = ({
  cell,
  additionalStyles,
  noValue = NO_VALUE,
}: TableCellTypesProps) => {
  const cellValue = cell?.value ? String(cell.value) : noValue;
  const isHyperlink = cell?.url && !!cell?.value;
  return (
    <p css={[commonLevelCss, additionalStyles]}>
      {isHyperlink ? (
        <Anchor flavor={Anchor.flavors.polar} href={cell.url || ""}>
          {cellValue}
        </Anchor>
      ) : (
        cellValue
      )}
    </p>
  );
};

export default GeneralTableCell;
